import React from 'react';
import './ConsentToOperateCompliance.css'; // Add a CSS file for specific styles if needed
import Header4 from '../../components/header/header4/Header4';
import ServicesHeroSection from '../../components/services_hero_section/ServicesHeroSection';
import Footer from '../../components/footer/Footer';
import backgroundimg from '../../assets/images/cto-1.jpg';
import ServicesOverviewSection from '../../components/services_overview_section/ServicesOverviewSection';
import img_cto_banner from '../../assets/images/img_peso1_banner.png'; // Replace with an appropriate image path
import { FaIndustry, FaRegFileAlt, FaHandsHelping, FaCheckCircle, FaFileSignature, FaSearchLocation, FaComments, FaPaperPlane } from 'react-icons/fa';
import ServicesBenefitsSection from '../../components/services_benefits_section/ServicesBenefitsSection';
import ServicesOurProcessSection from '../../components/services_our_process_section/ServicesOurProcessSection';
import ActsAndRulesSection from '../../components/acts_rules_section/ActsAndRulesSection';
import DocumentChecklist from '../../components/check_list_section/CheckListSection';

export default function ConsentToOperateCompliance() {
  const benefits = [
    {
      icon: <FaIndustry />,
      title: 'Operational Legitimacy',
      text: 'Legally operate your business by obtaining the required CTO permissions.',
    },
    {
      icon: <FaRegFileAlt />,
      title: 'Regulatory Compliance',
      text: 'Ensure full compliance with environmental and pollution control norms.',
    },
    {
      icon: <FaHandsHelping />,
      title: 'Community Trust',
      text: 'Build goodwill by adhering to eco-friendly practices and legal norms.',
    },
    {
      icon: <FaCheckCircle />,
      title: 'Smooth Operations',
      text: 'Avoid penalties, shutdowns, or disruptions due to regulatory violations.',
    },
  ];

  const steps = [
    {
      icon: <FaComments />,
      title: 'Consultation',
      description: 'Understand the specific requirements of your industry for CTO compliance.',
    },
    {
      icon: <FaFileSignature />,
      title: 'Document Preparation',
      description: 'Compile and prepare all necessary documentation as per guidelines.',
    },
    {
      icon: <FaSearchLocation />,
      title: 'Site Verification',
      description: 'Assist in site inspections and provide guidance on compliance measures.',
    },
    {
      icon: <FaPaperPlane />,
      title: 'Application Submission',
      description: 'Submit the application to the State Pollution Control Board or relevant authorities.',
    },
    {
      icon: <FaCheckCircle />,
      title: 'Approval and Compliance',
      description: 'Secure the Consent to Operate certificate and ensure compliance maintenance.',
    },
  ];

  const acts = [
    'Water (Prevention and Control of Pollution) Act, 1974',
    'Air (Prevention and Control of Pollution) Act, 1981',
    'Environment Protection Act, 1986',
    'Hazardous and Other Wastes (Management and Transboundary Movement) Rules, 2016',
    'Solid Waste Management Rules, 2016',
  ];

  const explanation =
    'Consent to Operate (CTO) Compliance ensures businesses operate within environmental guidelines and legal frameworks. It covers pollution control measures, waste management, and adherence to statutory norms as per the Environment Protection Act and related rules.';

  const checklistItems = [
    { name: 'Consent to Establish (CTE)', description: 'Proof of prior approval for setting up operations.' },
    { name: 'Pollution Control Equipment Details', description: 'Specifications and operational status of pollution control mechanisms.' },
    { name: 'Compliance Reports', description: 'Reports on adherence to environmental conditions from CTE.' },
    { name: 'Environmental Monitoring Data', description: 'Data on air, water, and noise pollution levels.' },
    { name: 'Waste Management Plans', description: 'Details on hazardous, solid, and other waste management processes.' },
  ];

  return (
    <>
      <Header4 />
      <ServicesHeroSection
        headline="Consent to Operate (CTO) Compliance Services"
        subheading="Navigate the complexities of obtaining Consent to Operate with expert guidance."
        ctaPrimary={{ text: 'Request Assistance', link: '/contact-us' }}
        ctaSecondary={{ text: 'Learn More', link: '/consent-to-operate-compliance' }}
        backgroundImage={backgroundimg} // Pass the background image here
      />

      <ServicesOverviewSection
        title="What is Consent to Operate Compliance?"
        description="Consent to Operate (CTO) Compliance is a mandatory regulatory requirement for businesses to ensure environmentally responsible operations. We provide end-to-end assistance in obtaining the required permissions from authorities."
        image={img_cto_banner} // Replace with a relevant image
        altText="Consent to Operate Compliance"
      />

      <ServicesBenefitsSection
        title="Why Consent to Operate Compliance Matters?"
        description="Learn why CTO compliance is essential for operational legitimacy and sustainable business practices."
        benefits={benefits}
      />

      <ActsAndRulesSection
        title="Acts and Rules Covered"
        subtitle="Key Legal Frameworks for CTO Compliance"
        acts={acts}
        explanation={explanation}
      />

      <ServicesOurProcessSection
        title="Our Consent to Operate Compliance Process"
        steps={steps}
      />

      <DocumentChecklist
        mainTitle="Complete Your Onboarding"
        checklistTitle="Consent to Operate Compliance Document Checklist"
        items={checklistItems}
      />

      <Footer />
    </>
  );
}
